import { CommonModule } from '@angular/common';
import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit, signal, ViewEncapsulation} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {ActivatedRoute} from "@angular/router";
type VGVElement = HTMLElement & {
  applicationId?: string;
};

type VGVCustomElementConstructor = CustomElementConstructor & {
  observedAttributes?: string[];
};
@Component({
  selector: 'app-vgv',
  standalone: true,
    imports: [
        MatIcon,
      CommonModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  templateUrl: './vgv.component.html',
  styleUrl: './vgv.component.css'
})
export class VgvComponent implements OnInit, OnDestroy {
  readonly ready = signal(false);
  readonly applicationId = signal('');
  private readonly route = inject(ActivatedRoute);



  ngOnInit(): void {
    customElements.whenDefined('vgv-app').then(() => {
      this.ready.set(true);

      this.route.queryParamMap.subscribe((params) => {
        this.applicationId.set(params.get('id') ?? '');
      });
    });
  }

  ngOnDestroy(): void {
    const el = document.querySelector('vgv-app') as VGVElement | null;
    if (el) {
      el.id = '';
    }
  }
  isIsselhorsterReady(): boolean {
    return this.ready();
  }
}
